import { hasSchedulingEngineFeature } from '../studyConfigUtils'

/**
 * Study-level gate for the new scheduling-engine Schedule step (GOLD-12163).
 * Enabled when `study.config.scheduling_engine` is present (typically `{}`).
 */
const useSchedulingEngineFeature = ({ study = {} } = {}) => {
  const hasSchedulingEngine = hasSchedulingEngineFeature(study)

  return {
    hasSchedulingEngine,
  }
}

export default useSchedulingEngineFeature
